angular.module('unergie.main')
.controller('offersCtrl', ($scope, $state, $uibModal, AlertManager, DataAccessOffers, NgTableParams, Tokens, TogglerUtils, FileUploader, BoFeaturesService, ErrorCatcher, organizations) => {
    $scope.isActive = (state) => $state.is(state)
    $scope.canDelete = false
    $scope.isPlum = TogglerUtils.isPlum()

    let hgzOffers = []
    let hgzOffersBase = []
    let hgzOffersHphc = []
    $scope.selectable_by_mapping = _.map(organizations, (d) => ({ label: d.id, value: d.id }))
    $scope.selectable_by_mapping.push({ label: 'client', value: 'client' })
    $scope.selectable_by_mapping.push({ label: 'Toutes les organisations', value: '*' })

    const refreshEnums = function () {
        hgzOffersBase = []
        hgzOffersHphc = []
        hgzOffers.forEach((elem) => {
            if (elem.plan_id === 10) {
                return hgzOffersBase.push({ value: elem.id, label: elem.id })
            }
            return hgzOffersHphc.push({ value: elem.id, label: elem.id })
        })
        $scope.offerFields.base.enum = hgzOffersBase
        $scope.offerFields.hphc.enum = hgzOffersHphc
        $scope.updateOfferFields = angular.copy($scope.offerFields)
        $scope.updateOfferFields.id.hidden = true
    }

    $scope.canUploadProviderOfferFis = BoFeaturesService.isFeatureOn('canUploadProviderOfferFis')

    const fisUploaderFactory = (offer) => {
        return new FileUploader({
            url: `/api-admin/ref-provider-offers/${offer.id}/upload-fis`,
            alias: 'file',
            autoUpload: true,
            method: 'POST',
            onSuccessItem(item, response, status, headers) {
                AlertManager.success(`Fichier FIS uploadé pour l'offre ${offer.id}`)
            },
            onErrorItem(item, response, status, headers) {
                AlertManager.error(response.message, 10000)
            },
        })
    }

    const refresh = function () {
        $scope.refreshing = true
        return DataAccessOffers.getOffers().$promise.then((data) => {
            refreshEnums()

            const dataWithUploader = data.map((offer) => {
                return Object.assign(offer, {
                    fisUploader: fisUploaderFactory(offer),
                })
            })

            $scope.tableParams = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 10,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: dataWithUploader })
        })
        .catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshing = false
        })
    }

    $scope.refresh = refresh
    refresh()

    $scope.delete = (offer) =>
        DataAccessOffers.delOffer({ id: offer.id }).$promise.then((data) => refresh()).catch(ErrorCatcher)


    const offerTemplate = {
        id: '',
        base: '',
        hphc: '',
        comments: '',
        has_pot: false,
        label: '',
        description: '',
        selectable_by: '',
        elec_type: '',
        elec_type_tooltip: '',
    }
    $scope.offerFields = {
        id: {
            label: 'Nom',
            required: true,
            type: 'text',
        },
        base: {
            label: 'Offre HGZ Base',
            required: true,
            type: 'select',
            enum: [],
        },
        hphc: {
            label: 'Offre HGZ Hp/Hc',
            required: true,
            type: 'select',
            enum: [],
        },
        comments: {
            label: 'Commentaires',
            type: 'text',
        },
        has_pot: {
            label: 'Offre cagnotte',
            type: 'radio',
            enum: [{ label: 'Oui', value: true }, { label: 'Non', value: false }],
        },
        label: {
            label: 'Libellé',
            type: 'text',
        },
        description: {
            label: 'Description',
            type: 'text',
        },
        elec_type: {
            label: `Type d'électricité`,
            type: 'text',
        },
        elec_type_tooltip: {
            label: `Description type d'élec.`,
            type: 'text',
        },
        selectable_by: {
            label: 'Disponible pour',
            type: 'text',
        },
    }

    if (!$scope.isPlum) {
        $scope.offerFields = _.omit($scope.offerFields, ['has_pot', 'elec_type', 'elec_type_tooltip'])
    }

    refreshEnums()

    const resetOfferPayload = () => {
        $scope.offerPayload = angular.copy(offerTemplate)
    }

    resetOfferPayload()

    $scope.addOffer = () =>
        DataAccessOffers.addOffer($scope.offerPayload).$promise.then(() => {
            AlertManager.success('Offre ajoutée')
            resetOfferPayload()
            return refresh()
        }).catch(ErrorCatcher)

    $scope.preparePayload = (datum) => {
        $scope.offerPayload = _.omit(datum, ['fisUploader'])
        $scope.offerPayload.selectable_by = datum.selectable_by ? datum.selectable_by.orgs.join(',') : ''
    }

    $scope.updateOffer = function (offer) {
        delete $scope.offerPayload.id
        $scope.offerPayload.selectable_by = { orgs: $scope.offerPayload.selectable_by.split(',') }
        DataAccessOffers.updateOffer({ id: offer.id }, _.omit($scope.offerPayload, ['fisUploader'])).$promise
        .then(() => {
            AlertManager.success('Offre modifiée')
            refresh()
        }).catch(ErrorCatcher)
    }

    $scope.deleteOffer = function (offer) {
    // Never delete STANDARD offer
        if ((offer.id === 'STANDARD') || (offer.id === 'EARLY_BIRD')) {
            return AlertManager.error('On a dit de ne pas la supprimer !!!')
        }
        return DataAccessOffers.delOffer({ id: offer.id }).$promise.then(() => {
            AlertManager.success('Offre supprimée')
            return refresh() }).catch(ErrorCatcher)
    }



    const refreshHgz = function () {
        $scope.refreshingHgz = true
        return DataAccessOffers.getHgzOffers().$promise.then((data) => {
            hgzOffers = data
            refreshEnums()
            data.forEach((elem) => {
                elem.cons = _.orderBy(elem.cons, 'temp_class', 'desc')
            })
            $scope.tableParamsHgz = new NgTableParams({
                page: ($scope.tableParams != null ? $scope.tableParams.page() : undefined) || 1,
                count: ($scope.tableParams != null ? $scope.tableParams.count() : undefined) || 10,
                filter: ($scope.tableParams != null ? $scope.tableParams.filter() : undefined) || {},
                sorting: ($scope.tableParams != null ? $scope.tableParams.sorting() : undefined) || {},
            }, { counts: [10, 25, 50, 100], dataset: data }) }).catch(ErrorCatcher)
        .finally(() => {
            $scope.refreshingHgz = false
        })
    }

    $scope.refreshHgz = refreshHgz
    refreshHgz()

    $scope.deleteHgz = (offer) =>
        DataAccessOffers.delHgzOffer({ id: offer.id }).$promise.then((data) => refreshHgz()).catch(ErrorCatcher)


    const offerHgzTemplate = {
        id: '',
        plan_id: '',
        abo_3: '',
        abo_6: '',
        abo_9: '',
        abo_12: '',
        abo_15: '',
        abo_18: '',
        abo_24: '',
        abo_30: '',
        abo_36: '',
    }
    $scope.offerHgzFields = {
        id: {
            label: 'Nom',
            required: true,
            type: 'text',
        },
        plan_id: {
            label: 'Base/HPHC',
            required: true,
            type: 'select',
            enum: [{ value: 10, label: 'Base' }, { value: 20, label: 'HP/HC' }],
        },
        abo_3: {
            label: 'Abonnement 3kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_6: {
            label: 'Abonnement 6kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_9: {
            label: 'Abonnement 9kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_12: {
            label: 'Abonnement 12kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_15: {
            label: 'Abonnement 15kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_18: {
            label: 'Abonnement 18kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_24: {
            label: 'Abonnement 24kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_30: {
            label: 'Abonnement 30kVA (€/an)',
            required: true,
            type: 'text',
        },
        abo_36: {
            label: 'Abonnement 36kVA (€/an)',
            required: true,
            type: 'text',
        },
    }

    $scope.updateOfferHgzConsFields = {
        cons_3: {
            label: 'Consommation 3kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_6: {
            label: 'Consommation 6kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_9: {
            label: 'Consommation 9kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_12: {
            label: 'Consommation 12kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_15: {
            label: 'Consommation 15kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_18: {
            label: 'Consommation 18kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_24: {
            label: 'Consommation 24kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_30: {
            label: 'Consommation 30kVA (€/KWh)',
            required: true,
            type: 'text',
        },
        cons_36: {
            label: 'Consommation 36kVA (€/KWh)',
            required: true,
            type: 'text',
        },
    }

    $scope.updateOfferHgzFields = angular.copy($scope.offerHgzFields)
    $scope.updateOfferHgzFields.id.hidden = true
    $scope.updateOfferHgzFields.plan_id.hidden = true

    const resetOfferHgzPayload = () => {
        $scope.offerHgzPayload = angular.copy(offerHgzTemplate)
    }

    resetOfferHgzPayload()

    $scope.addHgzOffer = () =>
        DataAccessOffers.addHgzOffer($scope.offerHgzPayload).$promise.then(() => {
            const cons = []
            if ($scope.offerHgzPayload.plan_id === 10) {
                cons.push({ id_hgz_offer: $scope.offerHgzPayload.id,
                    temp_class: 'BASE',
                    cons_3: '"100%"',
                    cons_6: '"100%"',
                    cons_9: '"100%"',
                    cons_12: '"100%"',
                    cons_15: '"100%"',
                    cons_18: '"100%"',
                    cons_24: '"100%"',
                    cons_30: '"100%"',
                    cons_36: '"100%"' })
            } else {
                cons.push({ id_hgz_offer: $scope.offerHgzPayload.id,
                    temp_class: 'HP',
                    cons_3: '"100%"',
                    cons_6: '"100%"',
                    cons_9: '"100%"',
                    cons_12: '"100%"',
                    cons_15: '"100%"',
                    cons_18: '"100%"',
                    cons_24: '"100%"',
                    cons_30: '"100%"',
                    cons_36: '"100%"' })
                cons.push({ id_hgz_offer: $scope.offerHgzPayload.id,
                    temp_class: 'HC',
                    cons_3: '"100%"',
                    cons_6: '"100%"',
                    cons_9: '"100%"',
                    cons_12: '"100%"',
                    cons_15: '"100%"',
                    cons_18: '"100%"',
                    cons_24: '"100%"',
                    cons_30: '"100%"',
                    cons_36: '"100%"' })
            }
            return DataAccessOffers.addHgzOfferCons(cons).$promise.then(() => {
                AlertManager.success('Offre Hgz ajoutée')
                resetOfferHgzPayload()
                return refreshHgz()
            }) }).catch(ErrorCatcher)


    $scope.updateHgzOffer = function (offer) {
        const offerPayload = angular.copy(offer)
        delete offerPayload.id
        delete offerPayload.cons
        _.each(offerPayload, (value, key) => {
            if (_.isString(value) && key.includes('abo_')) {
                offerPayload[key] = value.replace(/,/g, '.')
            }
        })
        return DataAccessOffers.updateHgzOffer({ id: offer.id }, offerPayload).$promise.then(() => {
            AlertManager.success('Offre modifiée')
            return refreshHgz() }).catch(ErrorCatcher)
    }

    $scope.deleteHgzOffer = (offer) =>
        DataAccessOffers.delHgzOffer({ id: offer.id }).$promise.then(() => {
            AlertManager.success('Offre supprimée')
            refreshHgz()
            return refresh() }).catch(ErrorCatcher)


    $scope.updateHgzOfferCons = function (offer) {
        const offerPayload = angular.copy(offer)
        delete offerPayload.id
        _.each(offerPayload, (value, key) => {
            if (_.isString(value) && key.includes('cons_')) {
                offerPayload[key] = value.replace(/,/g, '.')
            }
        })
        return DataAccessOffers.updateHgzOfferCons({ id: offer.id }, offerPayload).$promise.then(() => {
            AlertManager.success('Offre modifiée')
            return refreshHgz() }).catch(ErrorCatcher)
    }
})
